export default __webpack_public_path__ + "static/media/ifinance02.f068330a.png";